import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ConfiguratorCommonsService} from '@spartacus/product-configurator/rulebased';
import {ConfiguratorRouterExtractorService} from '@spartacus/product-configurator/common';
import {distinctUntilChanged, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HasPendingChangesService {
  constructor(
    private configuratorCommonsService: ConfiguratorCommonsService,
    private configRouterExtractorService: ConfiguratorRouterExtractorService,
  ) {}

  public hasPendingChanges(): Observable<boolean> {
    return this.configRouterExtractorService.extractRouterData().pipe(
      switchMap((routerData) => this.configuratorCommonsService.hasPendingChanges(routerData.owner)),
      distinctUntilChanged(),
    );
  }
}
